export const homePageUrl = () => `/`;
export const settingsPageUrl = () => `/settings`;

export const getFramesUrl = (uri: string | undefined) => {
  return `${process.env.REACT_APP_ASSETS_END_POINT}/${uri}`;
};

export const getPathFromUrl = (uri: string) => {
  if (uri) {
    const url = new URL(uri);
    return url.pathname;
  }
  return '';
};

export const getLinkFromCache = (playlistId: string, uri: string) => {
  const path = getPathFromUrl(uri);
  ///${playlistId}
  return `${process.env.REACT_APP_PI_ASSET_API_END_POINT}/${path.replace(/^\//, '')}`;
};

export const formatFormBody = (formData: any) => {
  let formBody = [];
  for (let property in formData) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(formData[property]);
    formBody.push(encodedKey + '=' + encodedValue);
  }
  return formBody.join('&');
};
